import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import "swiper/css/navigation";
import "swiper/css";
import "./ProductInfo.scss";
import { addCommas } from "@persian-tools/persian-tools";
import coffe from "assets/images/coffe1.jpg";

export default function ProductInfo({
  productImg,
  setproductImg,
  productInfo,
  setProductInfo,
}) {
  console.log("hi this is productImg", productInfo);
  const activeRangePrice = (array) => {
    let price = 0;
    for (let i = 0; i < array.length; i++) {
      if (array[i].is_active == "1") {
        price = array[i].from_price;
      }
    }
    return price;
  };
  const getTotalSaledCount = () => {
    let number = 0;
    for (let index = 0; index < productInfo.range?.length; index++) {
      number += parseInt(productInfo.range[index].saled_count);
      console.log("num", number);
    }
    return number;
  };
  const activeRange = productInfo.range.find((value) => value.is_active == "1");

  return (
    <div className="row px-1  productC-style mx-0">
      <div className="col-12 col-sm-3 col-md-3 ">
        <div className=" box-slider d-flex justify-content-center align-items-center">
          <div>
            <Swiper
              navigation={true}
              modules={[Navigation, Pagination]}
              slidesPerView={1}
              pagination={{
                clickable: true,
              }}
              className="mySwiper card product"
            >
              {productInfo?.cover_img?.length > 0 ? (
                <>
                  {productInfo.cover_img?.map((value, index) => {
                    console.log("imgs", value);
                    return (
                      <SwiperSlide key={index}>
                        <img
                          className="rounded"
                          style={{ width: "150px", height: "100px" }}
                          src={`http://marketgroup.tatdemo.ir/${value.url}`}
                        ></img>
                      </SwiperSlide>
                    );
                  })}
                </>
              ) : (
                <SwiperSlide>
                  <img
                    className="rounded"
                    style={{ width: "150px", height: "100px" }}
                    src={coffe}
                  ></img>
                </SwiperSlide>
              )}
            </Swiper>
          </div>
        </div>
      </div>
      <div className="col-12 col-sm-9 col-md-9 ">
        <div className=" description mx-0  ">
          <div
            className="row p-2 mx-0 container conInfo "
            style={{ backgroundColor: "#d4e0cc", borderRadius: "10px" }}
          >
            <div className="col-6 box-col p-0">
              <label className="label"> نام فروشگاه : </label>
              {/* <span style={{ margin: "8px", color: "#777372" }}>:</span> */}
              {productInfo.business[0]?.title ? (
                <span className="txt">{productInfo?.business[0]?.title}</span>
              ) : (
                <span className="txt">---</span>
              )}
            </div>
            <div className="col-6 box-col p-0">
              <label className="label"> عنوان محصول : </label>
              {/* <span style={{ margin: "8px", color: "#777372" }}>:</span> */}
              {productInfo.product[0]?.title ? (
                <span className="txt resTitle">
                  {productInfo?.product[0]?.title}
                </span>
              ) : (
                <span className="txt">---</span>
              )}
            </div>
            <div className="col-6 box-col p-0">
              <label className="label"> تعداد فروش : </label>
              {/* {activeRange?.from_count && activeRange?.saled_count ? (
                <span className="txt">
                  {getTotalSaledCount()}
                </span>
              ) : (
                <span className="txt">---</span>
              )} */}
              {productInfo.range.length > 0 ? (
                <span className="txt">{getTotalSaledCount()}</span>
              ) : (
                <span className="txt">---</span>
              )}
            </div>
            {/* <div className="col-6 box-col p-0">
              <label className="label"> مجموع مبلغ پرداخت شده : </label>
              <span className="txt">
                {addCommas(productInfo.totalAmountPaid || 0)}
              </span>
            </div> */}
            <div className="col-6 box-col p-0">
              <label className="label"> قیمت فعلی فروش : </label>
              {/* <span style={{ margin: "8px", color: "#777372" }}>:</span> */}
              {activeRange?.from_price && activeRange?.is_active == "1" ? (
                <span className="txt">
                  {addCommas(activeRange.from_price)} تومان
                </span>
              ) : (
                <span className="txt">---</span>
              )}
            </div>
            {/* <div className="col-6 box-col p-0">
              <label className="label"> مجموع سود خریداران : </label>
              <span className="txt">
                {addCommas(productInfo.totalAmountdiscount || 0)}
              </span>
            </div> */}
            {/* <div className="col-6 box-col">
              <label className="label"> قیمت رنج فعال : </label>
              {addCommas(activeRange(productInfo.range))} تومان */}
            {/* <span style={{ margin: "8px", color: "#777372" }}>:</span> */}
            {/* {productInfo.main_price ? (
                <span className="txt">
                  {addCommas(productInfo?.default_price)}
                </span>
              ) : (
                <span className="txt">---</span>
              )} */}
            {/* </div> */}

            {/* کامنت توضیحات محصول */}
            {/* <div className="col-12 mt-2 box-col p-0">
              <label className="label"> توضیحات محصول : </label>
              {productInfo.product[0]?.description ? (
                <span className="txt-desc">
                  {productInfo?.product[0]?.description}
                </span>
              ) : (
                <span className="txt-desc">---</span>
              )}
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
